import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styles from './_appPage.css'
import { selectSite } from 'services/site/selectors'
import OwnEveryMile from './own-every-mile'
import VictoryStories from './victory-stories'
import FindYourPath from './find-your-path-anywhere'
import YourGoals from './your-goals'
import DataToMakeYouBetter from './data-to-make-you-better'
import MakeMovesTogether from './make-moves-together'
import WeWill from './we-will'
import Syncs from './syncs'
import WorksWith from './works-with-devices'
import OtherApps from './other-apps'

const mapStateToProps = (state) => ({
  site: selectSite(state),
})

const mapDispatchToActions = {}

function AppPage (props) {
  const { site } = props
  const { slug } = site
  const showGoals = slug === 'fitness' || slug === 'run'
  const showSyncs = slug !== 'ride'

  return (
    <div className={styles.page}>
      <OwnEveryMile site={site} />
      <div className={styles.linesWrapper}>
        <VictoryStories />
        <DataToMakeYouBetter site={site} />
        { showGoals ? <YourGoals site={site} /> : null }
      </div>
      <div className={styles.topoWrapper}>
        <FindYourPath />
        <MakeMovesTogether site={site} />
      </div>
      <div className={styles.feedWrapper}>
        <WeWill site={site} />
        { showSyncs ? <Syncs site={site} /> : null }
      </div>
      <WorksWith />
      <OtherApps site={site} />
    </div>
  )
}

AppPage.propTypes = {
  site: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToActions)(AppPage)



// WEBPACK FOOTER //
// ./src/components/app-page/AppPage.jsx